import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";

import { AccountSettingService } from "src/app/Services/account-setting.service";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import Swal from "sweetalert2";

import { TranslateService } from "@ngx-translate/core";

import { CheckoutService } from "../../Services/checkout.service";
import { LoginUsersService } from "../../Services/login-users.service";
import { MarketingService } from "src/app/Services/marketing.service";
import { interval ,fromEvent} from "rxjs";
import { filter, map, merge } from "rxjs/operators";
import { QuantityLimitDialogComponent } from "../quantity-limit-dialog/quantity-limit-dialog.component";
declare let snaptr: any;

@Component({
    selector: "app-control-add-to-cart",
    templateUrl: "./control-add-to-cart.component.html",
    styleUrls: ["./control-add-to-cart.component.scss"],
})
export class ControlAddToCartComponent implements OnInit, OnChanges {
    @Input() product: any;
    @Input() styleCard: boolean = false;
    @Input() disabledButtonsToLoding: boolean = false;
    @Input() styleCartPage: boolean = false;
    @Input() styleCardHomeAr: boolean = false;
    @Input() isGridView: any;
    @Input() compareStyle: boolean = false;
    @Input() styleFavorites: boolean = false;
    @Input() stylePopup: boolean = false;
    @Input() isCartPage: boolean = false;
    @Input() styleDetails: boolean = false;
    @Input() customPadding: string = "";
    @Input() source: string = "";
    @Input() redirectToProduct: boolean = false;
    @Output() addToCart: EventEmitter<any> = new EventEmitter();
    @Output() cartEmit: EventEmitter<any> = new EventEmitter();
    @Output() ValidateCartStockEmit: EventEmitter<any> = new EventEmitter();
    @Output() stillOpenPopup: EventEmitter<any> = new EventEmitter();
    @ViewChild("emailDialgue", { static: false })
    emailDialgue!: TemplateRef<any>;

    productList: Array<any>;
    lang: string = "";
    user: any;
    notifyForm: FormGroup;
    environmentVariables: any;
    emailValidator : any =
    "^[a-zA-Z]{1}[a-zA-Z0-9.-_]*@[a-zA-Z]{1}[a-zA-Z.-]*[a-zA-Z]{1}[.][a-zA-Z]{2,}$";
    get email() {
        return this.notifyForm.get("email");
    }
      profile:any
      vistorId:any
      _items:any

    constructor(
        private embryoService: EmbryoService,
        private translate: TranslateService,
        public checkoutService: CheckoutService,
        public userLoginServies: LoginUsersService,
        private router: Router,
        public dialog: MatDialog,
        private account: AccountSettingService,
        private marketingService: MarketingService,
        private confgServ: StaticPagesService,
    ) {
        this.getInitilizingData();
        this.productList = [];
        this.notifyForm = new FormGroup({
            email: new FormControl("", [
                Validators.required,
                Validators.email,
                Validators.pattern(this.emailValidator),
            ]),
        });

        embryoService.emitLang.subscribe((lang: string) => {
            this.lang = lang;
            translate.setDefaultLang(lang);
        });
    }

    ngOnChanges() {
        this.lang = localStorage.getItem("lang") || "en";

        this.embryoService.productCartSub.subscribe((res) => {
            this.productList = res;
            // console.log(this.productList);
            
            if (this.productList?.length) this.checkAmount();
        });
    }
    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res: any) => {
            this.environmentVariables = res;
        });
    }
    flattenedArray :any =[]
    checkAmount() {
      var cartIds :any ;
      this.flattenedArray =[];
        if(!this.environmentVariables.SPLIT_CART_BY_VENDOR){
            this.flattenedArray = this.productList.map((item) => item.id);
        }
        else{
               this.productList.forEach(subArray=> {
                  if (subArray && subArray.items !== undefined) {
                  this.flattenedArray.push(...subArray.items);
                }
                      }); 
              this.productList = this.flattenedArray ;     
            this.flattenedArray = this.flattenedArray.map((x:any) => x && x.id);
        }
        if (this.flattenedArray.includes(this.product.id)) {
            const cartProduct = this.productList.find(
                (item) => item.id === this.product.id
            );
            this.product.amount = cartProduct.amount;
        }
    }

    ngOnInit() {
      // console.log('test');
      
        this.lang = localStorage.getItem("lang") || "en";
        this.translate.setDefaultLang(this.lang);
        this.profile = JSON.parse(localStorage.getItem('auth_user_crocs')!);
        this.vistorId = localStorage.getItem('vistorId');
    }

    public AddOrUpdateCart(product: any, type: string | null) {
        if (this.redirectToProduct == true) {
            const nameRouting = product.name.replace(/\s/g, "-");
            const parentId = product.parent_id || product.id;
            this.router.navigate(
                ["/" + this.lang + "/products", nameRouting, parentId],
                {
                    state: { name: nameRouting },
                    queryParams: { variant: product.id },
                }
            );
        }
        else {
            product.loading_cart = true;

            if (product.in_stock) {
                const cartProduct = {
                    reset: false,
                    items: [
                        {
                            id: product.id,
                            amount: product.amount,
                        },
                    ],
                };
            const interval$ = interval(1000);
                 const storage$ = fromEvent<StorageEvent>(window, 'storage').pipe(
                      filter((event) => event.key === 'auth_token'),
                      map((event) => event.newValue)
                    );
                const subscription = interval$.pipe(
                  filter(() => localStorage.getItem('auth_token') !== null),
                  merge(storage$)
                ).subscribe(() => {
                  // console.log('yes2');
                  subscription.unsubscribe();
                  
                  this.callApiAddProductToCart(product, cartProduct, type);
                });
            }
            else if (product.preorder) {
                const cartProduct = {
                    reset: false,
                    items: [
                        {
                            id: product.id,
                            amount: product.amount,
                        },
                    ],
                };


                const interval$ = interval(1000);
                const storage$ = fromEvent<StorageEvent>(window, 'storage').pipe(
                    filter((event) => event.key === 'auth_token'),
                    map((event) => event.newValue)
                );
                const subscription = interval$.pipe(
                    filter(() => localStorage.getItem('auth_token') !== null),
                    merge(storage$)
                ).subscribe(() => {
                    subscription.unsubscribe();
                    this.callApiAddProductToCart(product, cartProduct, type);
                });
               
            }
            else if (product.available_soon) {
                Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang === "en"
                            ? "Ops This product is available soon"
                            : "للاسف هذا سيتوفر قريبا"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
            }
            else {
                Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang === "en"
                            ? "Ops This product is out of stock"
                            : "للاسف نفد هذا المنتج من المخازن"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
            }
        }


        this._items = this.productList.map((product: any) => {
            return {
                id: product.id,
                quantity: product.amount,
                price: product.price
            };
        });
        this.marketingService.initCriteoq(this.profile, this.vistorId, 'addToCart', this._items);
        
        if (this.environmentVariables?.GOOGLE_CONVERSION_ID && this.environmentVariables?.GOOGLE_ANALYTICS_ID) {
            this.marketingService.GA4SingleProductEvent('add_to_cart', this.product);
        }
    }

    callApiAddProductToCart(product: any, cartProduct: any, type: any) {
        this.checkoutService.addOrUpdateToCart(cartProduct).subscribe(
            (rep: any) => {
                setTimeout(() => {
                    product.loading_cart = false;
                }, 200);
                if (rep.code === 200) {
                    let option;
                    let snapOption;
                    type === "add"
                        ? (option = "AddToCart")
                        : (option = "RemoveFromCart");
                    type === "add"
                        ? (snapOption = "ADD_CART")
                        : (snapOption = "RemoveFromCart");
                    this.marketingService.fbTracking("track", option, {
                        content_ids: [product.sku],
                        content_type: "product",
                        content_name: product.name,
                        value: product.discount_price
                            ? product.discount_price
                            : product.price,
                        contents: [
                            {
                                id: product.sku,
                                quantity: product.amount,
                            },
                        ],
                        currency: this.environmentVariables?.CURRENCY_CODE_EN,
                    });

                    
                    if(this.environmentVariables?.tiktokPixelId){
                        this.marketingService.ttqTracking('track', 'AddToCart',{
                            content_name: this.product.name,
                            content_category:
                                this.product?.category?.name,
                            content_id: this.product.id,
                            content_type: 'product',
                            value: this.product.discount_price
                                ? this.product.discount_price
                                : this.product.price,
                            currency: 'EGP',
                        })
                    }
                    
                    this.marketingService.snapTracking("track", 'ADD_CART', {
                        item_ids: [product.sku],
                        number_items: product.amount,
                        price: product.discount_price
                            ? product.discount_price
                            : product.price,
                        currency: this.environmentVariables?.CURRENCY_CODE_EN,
                    });

                                   if (this.environmentVariables?.GOOGLE_CONVERSION_ID) {


                          this.marketingService.googleConversionTracking(
                          "conversion",
                          this.environmentVariables?.GOOGLE_CONVERSION_ID,
                          this.environmentVariables?.GOOGLE_CONVERSION_LABEL_ADD_TO_CART,
                          this.environmentVariables?.GOOGLE_CONVERSION_TRANSACTION_ID
                        );
                      }
                    type === "add"
                        ? this.addMsg(product)
                        : this.removeMsg(product);

                    this.embryoService.productCartSub.next(
                        rep.data.items ? rep.data.items : rep.data
                    );
                    this.embryoService.productCartStatusCode.next(
                        rep
                    );
                    if (
                        this.environmentVariables
                            ?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER
                    ) {
                        this.environmentVariables.can_checkout =
                            rep.data?.can_checkout;
                    }
                    this.confgServ.setenvConfigOfflineApp(
                        this.environmentVariables
                    );
                    this.embryoService.productSuggestions.next(
                        rep.data.suggestions ? rep.data.suggestions : []
                    );
                }
                let obj = {
                    item_name: product.name,
                    item_id: product.id,
                    active: product.active,
                    price: product.discount_price
                        ? product.discount_price
                        : product.price,
                    item_brand:
                        product.details && product.details.brand
                            ? product.details.brand.name
                            : "",
                    item_category: product.category
                        ? product.category.name
                        : "-",
                    item_category2: product.category
                        ? product.category.sub_categories
                            ? product.category.sub_categories[0].name
                            : "-"
                        : "-",
                    item_list_name: product.actegory ? product.actegory.id : "",
                    item_list_id: product.actegory ? product.actegory.name : "",
                    index: "",
                    quantity: product.amount,
                };
                let result = {
                    event:
                        product.amount > 0 ? "add_to_cart" : "remove_from_cart",
                    ecommerce: {
                        currency:  this.environmentVariables?.CURRENCY_CODE_EN,
                        value: product.discount_price
                            ? product.discount_price
                            : product.price,
                        items: obj,
                        extras: this.account.googleAnalaticsUserData,
                    },
                };
            },
            () =>
                setTimeout(() => {
                    product.loading_cart = false;
                }, 200)
        );
    }

    addMsg(product: any) {
        console.log(product);
       
        this.marketingService.cartEvents("addToCart", product, "add");
        const toastOption = {
            title: "",
            msg: "",
        };
    
        if (product?.amount === product?.discount_max_per_period + 1) {
            this.openQuantityLimitDialog(
                {max_per_period : product.discount_max_per_period ,
                 item_price :  product?.item_price ? product?.item_price : product?.price
                
                })
           }
         if (this.lang === "en") {
                toastOption.title = "Cart";
                toastOption.msg = "Product added to cart successfully";
            } else {
                toastOption.title = "العربة";
                toastOption.msg = "تم إضافة المنتج إلى العربة بنجاح";
            }
        
    
        Swal.fire({
            html: `<p style='color:white'>${toastOption.msg}</p>`,
            width: 250,
            position: "bottom-end",
            background: "#51A351",
            timerProgressBar: true,
            showConfirmButton: false,
            timer: 3000,
            backdrop: false,
            allowOutsideClick: true,
        });
    }


    openQuantityLimitDialog(data :any): void {
        console.log(data);
        
        this.dialog.open(QuantityLimitDialogComponent, {
          width: '300px', 
          data:{data}
        });
      }

    removeMsg(product: any) {
        this.marketingService.cartEvents("removeFromCart", product, "remove");
        this.marketingService.initCriteoq(this.profile, this.vistorId, 'addToCart', this._items);

        const toastOption = {
            title: "Cart",
            msg: "",
        };
        if (this.lang === "en") {
            toastOption.title = "Cart";
            toastOption.msg = "Product removed from cart successfully";
        } else {
            toastOption.title = "العربة";
            toastOption.msg = "تم إزالة المنتج من العربة بنجاح";
        }
        Swal.fire({
            html: `<p style='color:white'>${toastOption.msg}</p>`,
            width: 250,
            position: "bottom-end",
            background: "#51A351",
            timerProgressBar: true,
            showConfirmButton: false,
            timer: 3000,
            backdrop: false,
            allowOutsideClick: true,
        });
    }

    addProductToCart(product: any) {
        if (this.redirectToProduct == true) {
            const nameRouting = product.name.replace(/\s/g, "-");
            const parentId = product.parent_id || product.id;
            this.router.navigate(
                // ["/" + this.lang + "/products", nameRouting, parentId],
                ['/' + this.lang + '/' + product?.slug] ,
                // {
                //     state: { name: nameRouting },
                //     queryParams: { variant: product.id },
                // }
            );
        } else {
            const itemName = this.product.name.replace(/\s/g, "-");
            if (
                this.environmentVariables &&
                this.environmentVariables?.PRODUCT_TYPE == "main"
            ) {
                if (this.source == "details") {
                    if (product.can_buy == null || product.can_buy > 0) {
                        product.amount =
                            product.amount + (product.cart_step || 1);
                        this.AddOrUpdateCart(product, "add");
                    }
                } else {
                    this.router.navigate(
                        ['/' + this.lang + '/' + product.product_variants[0]?.slug] ,

                        // [this.lang + `/products/${itemName}/${product.id}`],
                        // {
                        //     queryParams: {
                        //         variant:
                        //             product.product_variants[0]?.id ||
                        //             product?.id,
                        //     },
                        // }
                    );
                }
            } else {
                if (product.can_buy == null || product.can_buy > 0) {
                    product.amount = product.amount + (product.cart_step || 1);
                    this.AddOrUpdateCart(product, "add");
                }
            }
        }
        this.onClickGA4QuickAddToCartEvent(product)
    }

    onClickGA4QuickAddToCartEvent(product:any){
        console.log('product ', product)
        if(this.environmentVariables?.GOOGLE_CONVERSION_ID && this.environmentVariables?.GOOGLE_ANALYTICS_ID){
            let data = {
                currency:this.environmentVariables.CURRENCY_CODE_EN,
                value:product.price?? null,
                item_id:product.id,
                item_name:product.name,
                discount:product.discount_price?? null,
                price:product.price?? null,
                quantity:product?.amount ?? '1',
            }
            this.marketingService.GA4QuickAddToCartEvent(data);
            this.marketingService.GA4AddToCartEvent(data);

        }
    }
    onClickGA4RemoveFromCartEvent(product:any){
        console.log('product ', product)
        if(this.environmentVariables?.GOOGLE_CONVERSION_ID && this.environmentVariables?.GOOGLE_ANALYTICS_ID){
            let data = {
                currency:this.environmentVariables.CURRENCY_CODE_EN,
                value:product.price?? null,
                item_id:product.id,
                item_name:product.name,
                discount:product.discount_price?? null,
                price:product.price?? null,
                quantity:product?.amount ?? '1',
            }
            this.marketingService.GA4RemoveFromCartEvent(data)
        }
    }

    decrementAmountProduct(product: any) {
        const itemName = this.product.name.replace(/\s/g, "-");
        if (
            this.environmentVariables &&
            this.environmentVariables?.PRODUCT_TYPE == "main"
        ) {
            if (this.source == "details") {
                if (product.amount) {
                    product.amount = product.amount - (product.cart_step || 1);
                    this.AddOrUpdateCart(product, "remove");
                }
            } else {
                this.router.navigate(
                    [this.lang + `/products/${itemName}/${product.id}`],
                    {
                        queryParams: {
                            variant:
                                product.product_variants[0]?.id || product?.id,
                        },
                    }
                );
            }
        } else {
            if (product.amount) {
                product.amount = product.amount - (product.cart_step || 1);
                this.AddOrUpdateCart(product, "remove");
            }
        }
        this.onClickGA4RemoveFromCartEvent(product)
    }

    incrementAmountProduct(product: any) {
        const itemName = this.product.name.replace(/\s/g, "-");
        if (
            this.environmentVariables &&
            this.environmentVariables?.PRODUCT_TYPE == "main"
        ) {
            if (this.source == "details") {
                if (
                    product.amount < product.stock &&
                    (product.max_per_order == null ||
                        product.max_per_order > product.amount)
                ) {
                    product.amount = product.amount + (product.cart_step || 1);
                    this.AddOrUpdateCart(product, "add");
                } else {
                    this.embryoService.productCartStatusCode.next(
                          { code : 201}
                    );
                    Swal.fire({
                        html: `<p style='color:white'>${
                            this.lang == "en"
                                ? "You cannot add more"
                                : "لا يمكنك أضافة المزيد"
                        }</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
            } else {
                this.router.navigate(
                    // [this.lang + `/products/${itemName}/${product.id}`],
                    ['/' + this.lang + '/' + product.product_variants[0]?.slug] ,
                    // {
                    //     queryParams: {
                    //         variant:
                    //             product.product_variants[0]?.id || product?.id,
                    //     },
                    // }
                );
            }
        } else {
            if (
                product.amount < product.stock &&
                (product.max_per_order == null ||
                    product.max_per_order > product.amount)
            ) {
                product.amount = product.amount + (product.cart_step || 1);
                this.AddOrUpdateCart(product, "add");
            } else {
                this.embryoService.productCartStatusCode.next(
                        { code : 201}
                    );
                Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang == "en"
                            ? "You cannot add more"
                            : "لا يمكنك أضافة المزيد"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
            }
        }
    }

    notifyProduct(product: any) {
        this.user = JSON.parse(<string>localStorage.getItem("auth_user_crocs"));
        if (this.user) {
            this.notifyForm.controls.email.setValue(this.user.email);
        } else {
            this.notifyForm.controls.email.setValue("");
        }
        if(!this.environmentVariables.DISABLE_EMAIL_NOTIFY_ME){
            const dialogRef = this.dialog.open(this.emailDialgue, {
                width: "400px",
            });
            dialogRef.afterClosed().subscribe((result: any) => {
                if (result) {
                    this.embryoService
                        .PostRequestById(
                            "products/notify",
                            product.id,
                            this.notifyForm.value
                        )
                        .subscribe((response: any) => {
                            if (response.code === 200) {
                                Swal.fire({
                                    html: `<p style='color:white'>${
                                        this.lang == "en"
                                            ? "You will be notified when the item is available"
                                            : "سوف يتم تنبيهك عندما يكون المنتج متوفر"
                                    }</p>`,
                                    width: 250,
                                    position: "bottom-end",
                                    background: "#51A351",
                                    timerProgressBar: true,
                                    showConfirmButton: false,
                                    timer: 3000,
                                    backdrop: false,
                                    allowOutsideClick: true,
                                });
                            }
                        });
                }
            });
        }else{
            this.embryoService
            .PostRequestById(
                "products/notify",
                product.id,
                {}
            )
            .subscribe((response: any) => {
                if (response.code === 200) {
                    Swal.fire({
                        html: `<p style='color:white'>${
                            this.lang == "en"
                                ? "You will be notified when the item is available"
                                : "سوف يتم تنبيهك عندما يكون المنتج متوفر"
                        }</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#51A351",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
            });
        }
       
    }
    redirectToProductFun(product: any) {
        const parentId = product?.parent_id || product?.id;
        if (product?.slug) {
            this.router.navigate(
                // ["/" + this.lang + "/products", product?.slug, parentId],
                    ['/' + this.lang + '/' + product.slug] ,

                // {
                //     state: { name: product?.slug },
                //     queryParams: { variant: product.id },
                // }
            );
        } else {
            const nameRouting = product.name_en
                .replace(/[^\w\s]/gi, "-")
                .replace(/ /g, "-");
            this.router.navigate(
                // ["/" + this.lang + "/products", nameRouting, parentId],
                 ['/' + this.lang + '/' + product.slug] ,

                // {
                //     state: { name: nameRouting },
                //     queryParams: { variant: product.id },
                // }
            );
        }
    }
}
